export default "__VITE_ASSET__36be2555__"